"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  cursor: pointer;\n  text-align: center;\n  background-color: var(--color-brand, #fff);\n  padding: 15px 20px;\n  align-items: center;\n  justify-content: center;\n  text-transform: uppercase;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--color-popup-button-text, #000);\n  text-decoration: none;\n  transition: all ease 0.3s;\n  transform: translateZ(0) perspective(1px);\n  backface-visibility: hidden;\n  border: 2px solid transparent;\n  \n  &:hover {\n      background-color: var(--color-brand-hover, #f0f0f0);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * In this document we used css variable:
    --color-brand
    --color-brand-hover
    --color-popup-button-text
 */
var PopButton = _styledComponents.default.a(_templateObject());

exports.PopButton = PopButton;